export default "__VITE_ASSET__CnkuwjlH__"